import React, { useState, useEffect } from "react";
import stylesB from "./KanbanTableItem.module.scss";
import stylesW from "./KanbanTableItemW.module.scss";
import userInfo from "utils/userInfo";
import cx from "classnames";
import TaskItem from "../TaskItem/TaskItem";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import warning from "assets/side_pane_new_icons/exclamation.png";
import warningwhite from "assets/side_pane_new_icons/exclamationgreem.png";
import excam from "assets/side_pane_new_icons/exclam.png";
function KanbanTableItem({
  termTitle,
  term,
  loading,
  skeleton_number,
  taskCount,
  termTasks1,
  isSubtasks,
}) {
  const [loadMore, setLoadMore] = useState({
    currentTaskState: 5,
  });
  const [styles, setThem] = useState(stylesB);
  const user = userInfo();
  useEffect(() => {
    if (user?.them) {
      setThem(stylesW);
    } else {
      setThem(stylesB);
    }
  }, []);
  let renderContent;
  if (loading) {
    renderContent = (
      <div className={styles.skeletonWrapper}>
        {Array.from({ length: skeleton_number }).map((_, index) => (
          <div
            style={{
              height: "120px",
              background: "#E8E8EF",
              margin: "10px 8px",
              borderRadius: "6px",
              padding: "10px 12px 0 12px",
              width: "96%",
            }}
            key={index}
          >
            {[1, 2, 3, 4].map((cell) => (
              <Skeleton duration={0.8} key={cell} />
            ))}
          </div>
        ))}
      </div>
    );
  } else {
    const renderTask = termTasks1?.slice(0, loadMore.currentTaskState);
    renderContent = (
      <div className={styles.termBlock}>
        {[...renderTask].map((task) => (
          <TaskItem key={task.id} task={task} isSubtasks={isSubtasks} />
        ))}
        {renderTask.length >= 3 && taskCount !== renderTask.length ? (
          <>
          <div className={styles.showMore}>
            
            <span
              onClick={() =>
                setLoadMore({ currentTaskState: loadMore.currentTaskState + 3 })
              }
            >
              {" "}
              Загрузить еще {taskCount - renderTask.length >= 3 ? "3 из" : ""} {taskCount - renderTask.length}{" "}
            </span>
          </div>
          <div className={styles.showMore}>
          <span
            onClick={() =>
              setLoadMore({ currentTaskState: loadMore.currentTaskState + taskCount - renderTask.length })
            }
          >
            {" "}
            Загрузить все  {taskCount - renderTask.length}{" "}
          </span>
        </div>
        </>
        ) : (
         ""
        )}
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div
        className={cx(
          styles.termTitle,
          term == "overdue"
            ? styles.overdue
            : term == "today"
              ? styles.today
              : term == "week"
                ? styles.week
                : term == "mounth"
                  ? styles.mounth
                  : term == "longrange"
                    ? styles.longrange
                    : term == "noDeadline"
                      ? styles.no__deadline
                      : ""
        )}
      >
        {termTitle}{" "}
        {term === "overdue" ? (
          <img src={warning} className={styles.img} alt=""></img>
        ) : (
          ""
        )}
      </div>
      <div
        className={cx(
          styles.termBlock,
          term == "overdue"
            ? styles.overdue__item
            : term == "today"
              ? styles.today__item
              : term == "week"
                ? styles.week__item
                : term == "mounth"
                  ? styles.mounth__item
                  : term == "longrange"
                    ? styles.longrange__item
                    : term == "noDeadline"
                      ? styles.no__deadline__item
                      : ""
        )}
      >
        {loading ? (
          <SkeletonTheme
            baseColor="#33333382"
            highlightColor="#333333d4"
            borderRadius="6px"
            height="8px"
            direction="unset"
            duration={0}
          >
            {renderContent}
          </SkeletonTheme>
        ) : (
          renderContent
        )}
      </div>
    </div>
  );
}

export default React.memo(KanbanTableItem);
